export interface OffersFilter {
    key: FilterKey;
    title: string;
    type: FilterType;
    options: FilterOption[];
    initialOptions?: string[]; // options selected by default
    tooltip?: string;
    enabled?: boolean; // defines filter's visibility - visible (true) by default
}

export enum FilterKey {
    COVERAGE = 'COVERAGE',
    ADDITIONAL_COVERAGE = 'ADDITIONAL_COVERAGE',
    OWN_CONTRIBUTION = 'OWN_CONTRIBUTION',
    REPAIR_PARTS = 'REPAIR_PARTS',
    PARTS_DEPRECIATION = 'PARTS_DEPRECIATION',
    ASSISTANCE_CONDITIONS = 'ASSISTANCE_CONDITIONS',
    NNW_VALUE = 'NNW_VALUE',
    INSURANCE_COMPANY = 'INSURANCE_COMPANY',

    /** next filters */
    NNW_RANGE = 'NNW_RANGE',
    TOWING_LIMIT = 'TOWING_LIMIT',
    TERRITORIAL_SCOPE = 'TERRITORIAL_SCOPE',
    ACCIDENT_REPLACEMENT_CAR = 'ACCIDENT_REPLACEMENT_CAR',
    PRIMARY_COVERAGE = 'PRIMARY_COVERAGE',
}

export enum FilterType {
    CHECKBOX = 'CHECKBOX',
    RADIO = 'RADIO'
}

export interface FilterOption {
    key: string;
    label: string;
    translate?: boolean,
    isAnyOption?: boolean;
    selectedAndDisabled?: boolean;
    tooltip?: string;
}

export enum NNWValueFilterOption {
    ANY_NNW_VALUE = 'ANY_NNW_VALUE',
    UNDER_20 = 'UNDER_20',
    FROM_20_TO_40 = 'FROM_20_TO_40',
    ABOVE_40 = 'ABOVE_40'
}

export enum NextNNWValueFilterOption {
    UNDER_10 = 'UNDER_10',
    ABOVE_10 = 'ABOVE_10'
}

export enum NextTowingLimitFilterOption {
    UNDER_150KM = 'UNDER_150KM',
    FROM_150KM_TO_300KM = 'FROM_150KM_TO_300KM',
    ABOVE_300KM = 'ABOVE_300KM',
}

export enum NextTerritorialScopeFilterOption {
    POLAND = 'POLAND',
    POLAND_EUROPE = 'POLAND_EUROPE',
}

export enum NextAccidentReplacementCarFilterOption {
    UNDER_3_DAYS = 'UNDER_3_DAYS',
    FROM_3_TO_4_DAYS = 'FROM_3_TO_4_DAYS',
    ABOVE_4_DAYS = 'ABOVE_4_DAYS',
}

export enum AssistanceConditionsFilterOption {
    ANY_ASSISTANCE_CONDITION = 'ANY_ASSISTANCE_CONDITION',
    ACCIDENT = 'ACCIDENT',
    BREAKDOWN = 'BREAKDOWN',
    POLAND = 'POLAND',
    EUROPE = 'EUROPE',
    ACCIDENT_REPLACEMENT_CAR = 'ACCIDENT_REPLACEMENT_CAR',
    BREAKDOWN_REPLACEMENT_CAR = 'BREAKDOWN_REPLACEMENT_CAR',
}

export enum PartsDepreciationFilterOption {
    ANY_DEPRECIATION = 'ANY_DEPRECIATION',
    WITH_DEPRECIATION = 'WITH_DEPRECIATION',
    WITHOUT_DEPRECIATION = 'WITHOUT_DEPRECIATION'
}

export enum RepairPartsFilterOption {
    ANY_REPAIR_PARTS = 'ANY_REPAIR_PARTS',
    ORIGINAL = 'ORIGINAL',
    REPLACEMENTS = 'REPLACEMENTS'
}

export enum OwnContributionFilterOption {
    ANY_CONTRIBUTION = 'ANY_CONTRIBUTION',
    WITHOUT_OWN_CONTRIBUTION = 'WITHOUT_OWN_CONTRIBUTION',
    WITH_OWN_CONTRIBUTION = 'WITH_OWN_CONTRIBUTION'
}

export enum CoveragesFilterOption {
    OC = 'OC',
    OC_AC_MINI = 'OC_AC_MINI',
    OC_AC = 'OC_AC'
}

export enum AdditionalCoveragesFilterOption {
    NNW = 'NNW',
    ASSISTANCE = 'ASSISTANCE',
    OTHER_GLASS = 'OTHER_GLASS'
}

export interface FiltersState {
    [filterKey: string]: any[];
};

export enum FiltersApplicationMode {
    AUTOMATIC = 'AUTOMATIC', // filter is applied immediately after user's action (active on desktop)
    ON_CONFIRMATION = 'ON_CONFIRMATION' // filter is applied after user's confirmation on dialog (active on mobile)
}

export enum FilterMessage {
    CLEAR_ASSISTANCE_CONDITIONS = 'CLEAR_ASSISTANCE_CONDITIONS',
    CLEAR_AC_CONDITIONS = 'CLEAR_AC_CONDITIONS',
    SELECT_OC_AC = 'SELECT_OC_AC',
    REMOVE_OC_AC = 'REMOVE_OC_AC',
    SELECT_ALL_FILTER_OPTIONS = 'SELECT_ALL_FILTER_OPTIONS',
    RESET_ALL_FILTER_OPTIONS = 'RESET_ALL_FILTER_OPTIONS',
}

export interface FilterMessageEvent {
    targets: FilterKey[];
    message: FilterMessage;
}

export interface FilterOffersCountState {
    key: FilterKey;
    optionsOffersCounts: FilterOptionOffersCount[];
}

export interface FilterOptionOffersCount {
    optionKey: string;
    offersCount: number;
}
